module.exports = __webpack_public_path__ + "static/img/y40.1829b1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y40.jpg
// module id = RQbu
// module chunks = 1